import React, {useMemo} from 'react';
import {Breadcrumb, Card, Space} from 'antd';
import Text from 'antd/lib/typography/Text';
import './AppSideLayout.less';
import Flex from '../Flex';
import Title from 'antd/lib/typography/Title';
import {ISideLayoutCatalogs} from './AppLayout';
import classNames from 'classnames';
import {useHistory} from 'react-router-dom';
import {SpecialtyCommitteeList, WorkCommitteeList} from '../../utils/CommitteeList';

export const SideLayoutAboutCatalogs: ISideLayoutCatalogs = {
  title: '关于 SCS',
  list: [
    {title: '学会简介', href: '/about/introduction'},
    {title: '组织机构', href: '/about/organization'},
    {title: '章程条例', href: '/about/constitution'},
    {title: '最新公告', href: '/notice/list'},
    {title: '大事记', href: '/about/history'},
    {title: '联系我们', href: '/about/contact'},
    {title: '在线入会', href: '/about/register'},
    {title: '双选会员', href: '/about/doubleSelectRegister'},
  ],
};

export const SideLayoutWorkCommitteeCatalogs: ISideLayoutCatalogs = {
  title: '工作委员会',
  list: WorkCommitteeList.map(i => ({title: i, href: `/workCommittee/${i}`})),
};

export const SideLayoutSpecialtyCommitteeCatalogs: ISideLayoutCatalogs = {
  title: '专业委员会',
  list: SpecialtyCommitteeList.map(i => ({title: i, href: `/specialtyCommittee/${i}`})),
};

export const SideLayoutActivityCatalogs: ISideLayoutCatalogs = {
  title: '会议活动',
  list: [
    {title: '会议活动总结', href: '/activity/summarize'},
    {title: '推荐会议活动', href: '/activity/recommend'},
    {title: '第十次会员代表大会', href: '/about/congress'},
  ],
};

export const SideLayoutPartnerCatalogs: ISideLayoutCatalogs = {
  title: '团体会员风采',
  list: [{title: '团体会员风采', href: '/partner/list'}],
};

export const SideLayoutOrganizationCatalogs: ISideLayoutCatalogs = {
  title: '组织架构',
  list: [
    {title: '党工组', href: '/organization/党工组'},
    {title: '理事会', href: '/organization/理事会'},
    {title: '监事会', href: '/organization/监事会'},
  ],
};

export const SideLayoutProfileCatalogs: ISideLayoutCatalogs = {
  title: '个人中心',
  list: [
    {title: '个人信息', href: '/profile/detail'},
    {title: '会员缴费', href: '/profile/payment'},
    {title: '电子会员证', href: '/profile/card'},
  ],
};

export const SideLayoutAwardCatalogs: ISideLayoutCatalogs = {
  title: '学会奖励',
  list: [
    {title: '优秀博士学位论文奖', href: '/award/优秀博士学位论文奖'},
    {title: '优秀硕士学位论文奖', href: '/award/优秀硕士学位论文奖'},
    {title: '教学成果奖', href: '/award/教学成果奖'},
    {title: '科技英才', href: '/award/科技英才'},
    {title: '科学技术奖', href: '/award/科学技术奖'},
    {title: '少年图灵奖', href: '/award/少年图灵奖'},
  ],
};

export const AllCatalogs = [
  SideLayoutAboutCatalogs,
  SideLayoutWorkCommitteeCatalogs,
  SideLayoutSpecialtyCommitteeCatalogs,
  SideLayoutActivityCatalogs,
  SideLayoutPartnerCatalogs,
  SideLayoutOrganizationCatalogs,
  SideLayoutProfileCatalogs,
  SideLayoutAwardCatalogs,
];

export default function AppSideLayout(props: {children: any; title: string}) {
  const catalogs = useMemo(() => {
    const exist = AllCatalogs.find(i => !!i.list.find(j => j.title === props.title));
    if (exist) return exist;
    return SideLayoutAboutCatalogs;
  }, [props.title]);

  const history = useHistory();

  return (
    <div className={'AppSideLayout'}>
      <Space className={'m-t-15 m-b-15'}>
        <Text>当前位置在: </Text>
        <Breadcrumb>
          <Breadcrumb.Item>首页</Breadcrumb.Item>
          <Breadcrumb.Item>{catalogs.title}</Breadcrumb.Item>
          <Breadcrumb.Item>{props.title}</Breadcrumb.Item>
        </Breadcrumb>
      </Space>
      <Flex>
        <div className={'AppSideBar'}>
          <div>
            <div className={'AppSideBarHeader'}>
              <div style={{textAlign: 'center'}}>
                <Title level={4} style={{color: 'white', fontSize: 18, marginBottom: 3}}>
                  {catalogs.title}
                </Title>
                <Text style={{color: 'white'}}>Shanghai Computer Society</Text>
              </div>
            </div>
            <div className={'AppSideBarList'}>
              {catalogs.list.map(i => (
                <div
                  onClick={() => history.push(i.href)}
                  className={classNames({
                    AppSideBarListItem: true,
                    AppSideBarListItemActive: i.title === props.title,
                  })}
                  key={i.title}>
                  {i.title}
                </div>
              ))}
            </div>
          </div>
          <div className={'AppSideBarFooter'}>
            <div className={'AppSideBarFooterDivider'} />
            <div>电话：021-53828933</div>
            <div>E-mail：computer@stn.sh.cn</div>
            <div>地址：上海市南昌路47号3号楼303室</div>
          </div>
        </div>
        {props.children}
      </Flex>
    </div>
  );
}
